<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addOccupancyType()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'NEW' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showOccupancyTypes()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-occupancy-type-list
          [occupancyTypes]="occupancyTypes"
          [meta]="meta"
          [loadingOccupancyTypes]="loadingOccupancyTypes"
          [defaultLanguage]="defaultLanguage"
          (selectedOccupancyType)="onSelectedOccupancyType($event)"
        ></app-occupancy-type-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-occupancy-type-detail
        [occupancyType]="occupancyType"
        [mode]="mode"
        [defaultLanguage]="defaultLanguage"
        [additionalLanguages]="additionalLanguages"
        [isModal]="true"
        (savedOccupancyType)="onSavedOccupancyType($event)"
        (canceledOccupancyType)="onCanceledOccupancyType()"
      ></app-occupancy-type-detail>
    </div>
  </div>
</div>
